import React, { FC } from 'react';
import { FolderThumbnail } from '../../../../components/common';
import { MediaManagerSDKFolder } from '../../../../utils/media-manager-sdk';
import { IOuter } from '../ItemDemonstration.types';

export const Folder: FC<IOuter> = ({ item, className, saveRef }) => (
  <div className={className} data-hook="expanded-view-folder-demonstration" ref={saveRef}>
    <FolderThumbnail folder={item as MediaManagerSDKFolder} dark />
  </div>
);
